import React, { useEffect, useRef, useState } from 'react';
import { Paper, Stack, Typography, TextField, IconButton, InputAdornment, CircularProgress } from '@mui/material';
import CropFreeIcon from '@mui/icons-material/CropFree';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { useTheme } from '@mui/material/styles';
import { tokens } from '../../theme';

export default function ScanCards({ onScan, onCameraClick, busy = false, disabled = false }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [value, setValue] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (!disabled && !busy) inputRef.current?.focus();
  }, [busy, disabled]);

  const submit = () => {
    const code = value.trim();
    if (!code || busy || disabled) return;
    onScan?.(code);
    setValue('');
  };

  return (
    <Paper sx={{ p: { xs: 2, md: 2.5 }, borderRadius: 2 }} elevation={0}>
      <Stack direction="row" spacing={1.2} alignItems="center" sx={{ mb: 1.5 }}>
        <CropFreeIcon sx={{ color: colors.primary[500] }} />
        <div>
          <Typography sx={{ fontSize: 20, color: colors.primary[500], fontWeight: 700 }}>สแกน QR Code</Typography>
          <Typography sx={{ fontSize: 16, color: 'text.secondary' }}>ยิงเครื่องสแกนได้ทันที หรือแตะรูปกล้องเพื่อสแกนด้วยมือถือ</Typography>
        </div>
      </Stack>
      <TextField
        inputRef={inputRef}
        fullWidth
        value={value}
        disabled={busy || disabled}
        placeholder={disabled ? 'กรุณาเลือกสถานที่ก่อนสแกน' : 'พร้อมรับ QR Code...'}
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            submit();
          }
        }}
        inputProps={{ 'aria-label': 'ข้อมูลจากเครื่องสแกน' }}
        InputProps={{
          startAdornment: <InputAdornment position="start"><CropFreeIcon color="primary" /></InputAdornment>,
          endAdornment: (
            <InputAdornment position="end">
              {busy ? <CircularProgress size={24} /> : (
                <IconButton aria-label="เปิดกล้องสแกน QR Code" onClick={onCameraClick} disabled={disabled} edge="end">
                  <CameraAltIcon />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
      />
    </Paper>
  );
}
